<div class="renter-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">Please log in first.</div>

  <section *ngIf="isAuthenticated" class="list-content">
    <div class="list-toolbar">
      <div class="message info" *ngIf="isLoading">{{ status }}</div>
      <div class="message subtle" *ngIf="!isLoading && !error">Limit: {{ activeRenterCount }}/{{ renterCreateLimit }}</div>
    </div>
    <div class="message error" *ngIf="error">{{ error }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="renterList"
      [deletedMode]="deletedMode"
      [showMenuInDeletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [emptyMessage]="'No renters found.'"
      [menuActions]="visibleRenterMenuActions"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (menuAction)="onMenuActionFromList($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedRenter" (click)="closeDetailsModal()">
    <div class="details-modal renter-details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t" (click)="closeDetailsModal()">&times;</button>
      <h3>{{ 'renter.detailsTitle' | t:'Renter Details' }}</h3>

      <div class="renter-details-top">
        <section class="renter-details-block section-card">
          <h4>{{ 'renter.renterInformation' | t:'Renter Information' }}</h4>
          <div class="renter-profile-card renter-profile-clickable" (click)="openRenterInfoModal()">
            <span class="renter-profile-avatar-wrap" *ngIf="firstRenterImageAttachment() as renterImage; else noCardImage">
              <img *ngIf="renterProfileImageUrl; else renterProfileFallback" [src]="renterProfileImageUrl" [alt]="'renter.renterInformation' | t:'Renter profile image'" class="renter-profile-avatar" />
              <button
                type="button"
                class="renter-avatar-eye-btn"
                [attr.aria-label]="'common.show' | t:'View image'"
                (click)="openAttachmentPreview(renterImage); $event.stopPropagation()"
              >
                <span class="renter-avatar-eye-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" focusable="false">
                    <path d="M12 5C6.5 5 2 12 2 12s4.5 7 10 7 10-7 10-7-4.5-7-10-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"></path>
                    <circle cx="12" cy="12" r="2.2"></circle>
                  </svg>
                </span>
              </button>
            </span>
            <ng-template #noCardImage>
              <span class="renter-profile-avatar-wrap">
                <span class="renter-profile-avatar-fallback">{{ renterInitials() }}</span>
              </span>
            </ng-template>
            <ng-template #renterProfileFallback>
              <span class="renter-profile-avatar-fallback">{{ renterInitials() }}</span>
            </ng-template>
            <div class="renter-profile-meta">
              <div class="renter-profile-name">{{ selectedRenter.renterName || ('common.na' | t:'N/A') }}</div>
              <div class="renter-profile-sub">{{ selectedRenter.renterMobile || ('common.na' | t:'N/A') }}</div>
              <div class="renter-profile-sub">{{ selectedRenter.renterEmail || ('common.na' | t:'N/A') }}</div>
              <div class="renter-profile-username-row" (click)="$event.stopPropagation()">
                <span class="renter-profile-username-label">{{ 'renter.username' | t:'Username' }}</span>
                <span class="renter-profile-username-value">{{ maskedRenterUsername() }}</span>
                <button
                  type="button"
                  class="renter-profile-username-btn"
                  [attr.aria-label]="'common.copy' | t:'Copy'"
                  (click)="copyRenterUsername()"
                  [disabled]="renterUsernameValue() === 'N/A'"
                >
                  <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                    <path d="M8 7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1H8V7z"></path>
                    <path d="M6 9h7a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H6z"></path>
                  </svg>
                  <span class="renter-profile-copy-tooltip" *ngIf="renterUsernameCopied">{{ 'common.copied' | t:'Copied' }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section class="renter-details-block section-card">
          <h4>{{ 'renter.homeInformation' | t:'Home Information' }}</h4>
          <div class="home-info-card">
            <div class="home-info-row">
              <span class="home-info-label">{{ 'report.flat' | t:'Flat' }}</span>
              <span class="home-info-value home-info-value-ellipsis" [title]="mappingFlatLabel(selectedRenterMapping)">{{ mappingFlatLabel(selectedRenterMapping) }}</span>
            </div>
            <div class="home-info-row">
              <span class="home-info-label">{{ 'renter.status' | t:'Status' }}</span>
              <span class="home-info-value">{{ mappingStatusLabel(selectedRenterMapping?.status) }}</span>
            </div>
            <div class="home-info-row">
              <span class="home-info-label">{{ 'renter.startDate' | t:'Start Date' }}</span>
              <span class="home-info-value">{{ formatDate(selectedRenterMapping?.renterStartDate) }}</span>
            </div>
            <div class="home-info-row" *ngIf="selectedRenterMapping?.renterEndDate">
              <span class="home-info-label">{{ 'renter.endDate' | t:'End Date' }}</span>
              <span class="home-info-value">{{ formatDate(selectedRenterMapping?.renterEndDate) }}</span>
            </div>
            <div class="home-info-row home-info-row-full" *ngIf="(selectedRenterMapping?.advanceAmount ?? 0) > 0">
              <span class="home-info-value home-info-accent-line">
                <span class="home-info-accent-text">{{ 'renter.advance' | t:'Advance' }}: <span class="home-info-number">{{ formatAmount(selectedRenterMapping?.advanceAmount) }}</span></span>
                &nbsp;&nbsp;
                <span class="home-info-accent-text">{{ 'renter.used' | t:'Used' }}: <span class="home-info-number">{{ formatAmount(selectedRenterMapping?.usedAdvanceAmount) }}</span></span>
                &nbsp;&nbsp;
                <span class="home-info-accent-text">{{ 'renter.remain' | t:'Remain' }}: <span class="home-info-number">{{ formatAmount(mappingRemainingAdvance(selectedRenterMapping)) }}</span></span>
              </span>
            </div>
          </div>
        </section>

        <section class="renter-details-media section-card">
          <div class="renter-details-docs">
            <div class="renter-details-docs-title">{{ 'renter.agreementDocuments' | t:'Additional Documents' }}</div>
            <div class="renter-details-docs-list" *ngIf="selectedAgreementAttachments().length > 0; else noAgreementDocs">
              <button
                type="button"
                class="renter-details-doc-link"
                *ngFor="let attachment of selectedAgreementAttachments()"
                (click)="openAttachmentPreview(attachment)"
              >
                {{ attachment.attachmentFileName || ('Document #' + attachment.id) }}
              </button>
            </div>
            <ng-template #noAgreementDocs>
              <div class="renter-details-docs-empty">{{ 'renter.noAgreementDocument' | t:'No additional document uploaded.' }}</div>
            </ng-template>
          </div>
        </section>
      </div>

      <div class="renter-details-table-wrap">
        <div class="renter-details-table-controls">
          <div class="details-control-dropdown">
            <app-common-dropdown
              [compact]="true"
              [dropdownObj]="{
                name: 'detailsFlatId',
                label: 'filter.flat',
                placeholder: 'placeholder.selectFlat',
                valueKey: 'value',
                display1: 'label',
                isSearchable: true,
                options: renterDetailsFlatDropdownOptions()
              }"
              [value]="selectedFlatId"
              (valueChange)="onDetailsFlatDropdownChange($event)"
            ></app-common-dropdown>
          </div>
          <div class="details-control-dropdown details-control-year">
            <app-common-dropdown
              [compact]="true"
              [dropdownObj]="{
                name: 'detailsPaymentYear',
                label: 'topHeader.year',
                placeholder: 'placeholder.selectYear',
                valueKey: 'value',
                display1: 'label',
                isSearchable: true,
                options: detailsYearOptions
              }"
              [value]="selectedPaymentYear"
              (valueChange)="onDetailsYearDropdownChange($event)"
            ></app-common-dropdown>
          </div>
          <button type="button" class="details-control-btn" (click)="applyDetailsFilters()">{{ 'common.search' | t:'Search' }}</button>
          <div class="details-export-actions" *ngIf="renterPaymentRows.length > 0">
            <button type="button" class="details-export-btn details-export-pdf" (click)="downloadDetailsPdfReport()">
              <span class="details-export-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M12 3a1 1 0 0 1 1 1v8.59l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 3.99a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42L11 12.6V4a1 1 0 0 1 1-1z"></path>
                  <path d="M5 18a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"></path>
                </svg>
              </span>
              <span>{{ 'report.pdf' | t:'PDF' }}</span>
            </button>
            <!--
            <button type="button" class="details-export-btn details-export-excel" (click)="downloadDetailsExcelReport()">
              <span class="details-export-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M12 3a1 1 0 0 1 1 1v8.59l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 3.99a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42L11 12.6V4a1 1 0 0 1 1-1z"></path>
                  <path d="M5 18a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"></path>
                </svg>
              </span>
              <span>Excel</span>
            </button>
            -->
          </div>
        </div>

        <div class="renter-details-table-head">
          <div>{{ 'report.monthName' | t:'Month Name' }}</div>
          <div>{{ 'report.paymentDate' | t:'Payment Date' }}</div>
          <div>{{ 'report.flatRent' | t:'Flat Rent' }}</div>
          <div>{{ 'report.gasBill' | t:'Gas Bill' }}</div>
          <div>{{ 'report.electricBill' | t:'Electric Bill' }}</div>
          <div>{{ 'report.waterBill' | t:'Water Bill' }}</div>
          <div>{{ 'report.serviceChargeOther' | t:'Service Charge + Other' }}</div>
          <div>{{ (selectedRenterMapping?.flat?.negativeChargeName || '').trim() || ('flat.negativeCharge' | t:'Negative Charge') }}</div>
          <div>{{ 'report.adjustFromAdvance' | t:'Adjust From Advance' }}</div>
          <div>{{ 'report.totalAmount' | t:'Total Amount' }}</div>
        </div>

        <div class="renter-details-table-loading" *ngIf="isDetailsDataLoading">
          <app-content-skeleton
            variant="table"
            [columns]="10"
            [rows]="6"
          ></app-content-skeleton>
        </div>
        <div class="renter-details-table-empty" *ngIf="!isDetailsDataLoading && detailsDataError">{{ detailsDataError }}</div>

        <div class="renter-details-table-body" *ngIf="!isDetailsDataLoading && !detailsDataError && renterPaymentRows.length > 0; else noRenterPaymentRows">
          <div class="renter-details-table-row" *ngFor="let row of renterPaymentRows">
            <div class="doc-cell">{{ row.monthLabel }}</div>
            <div class="doc-cell">{{ row.paymentDateLabel }}</div>
            <div class="doc-cell">{{ row.rentLabel }}</div>
            <div class="doc-cell">{{ row.gasLabel }}</div>
            <div class="doc-cell">{{ row.electricLabel }}</div>
            <div class="doc-cell">{{ row.waterLabel }}</div>
            <div class="doc-cell">{{ row.serviceLabel }}</div>
            <div class="doc-cell">{{ row.otherLabel }}</div>
            <div class="doc-cell">{{ row.advanceAdjustedLabel }}</div>
            <div class="doc-cell total-cell">{{ row.totalLabel }}</div>
          </div>
          <div class="renter-details-table-row renter-details-table-total-row" *ngIf="renterPaymentFinalTotalRow() as totals">
            <div class="doc-cell">{{ totals.monthLabel }}</div>
            <div class="doc-cell">{{ totals.paymentDateLabel }}</div>
            <div class="doc-cell">{{ totals.rentLabel }}</div>
            <div class="doc-cell">{{ totals.gasLabel }}</div>
            <div class="doc-cell">{{ totals.electricLabel }}</div>
            <div class="doc-cell">{{ totals.waterLabel }}</div>
            <div class="doc-cell">{{ totals.serviceLabel }}</div>
            <div class="doc-cell">{{ totals.otherLabel }}</div>
            <div class="doc-cell">{{ totals.advanceAdjustedLabel }}</div>
            <div class="doc-cell total-cell">{{ totals.totalLabel }}</div>
          </div>
        </div>
        <ng-template #noRenterPaymentRows>
          <div class="renter-details-table-empty" *ngIf="!isDetailsDataLoading && !detailsDataError">
            {{ 'renter.noPaymentData' | t:'No payment data found.' }}
          </div>
        </ng-template>
      </div>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeDetailsModal()">{{ 'common.close' | t:'Close' }}</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isRenterInfoOpen && selectedRenter" (click)="closeRenterInfoModal()">
    <div class="details-modal renter-info-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t" (click)="closeRenterInfoModal()">&times;</button>
      <h3>{{ 'renter.detailsFullTitle' | t:'Renter Full Information' }}</h3>
      <div class="details-grid">
        <div class="details-item"><span class="label">{{ 'renter.name' | t:'Name' }}</span><span class="value">{{ selectedRenter.renterName || ('common.na' | t:'N/A') }}</span></div>
        <div class="details-item"><span class="label">{{ 'renter.mobile' | t:'Mobile' }}</span><span class="value">{{ selectedRenter.renterMobile || ('common.na' | t:'N/A') }}</span></div>
        <div class="details-item"><span class="label">{{ 'renter.email' | t:'Email' }}</span><span class="value">{{ selectedRenter.renterEmail || ('common.na' | t:'N/A') }}</span></div>
        <div class="details-item"><span class="label">{{ 'renter.photoIdNo' | t:'Photo ID No' }}</span><span class="value">{{ selectedRenter.renterPhotoIdNo || ('common.na' | t:'N/A') }}</span></div>
        <div class="details-item"><span class="label">{{ 'renter.permanentAddress' | t:'Permanent Address' }}</span><span class="value">{{ selectedRenter.renterPermanentAddress || ('common.na' | t:'N/A') }}</span></div>
        <div class="details-item"><span class="label">{{ 'renter.previousAddress' | t:'Previous Address' }}</span><span class="value">{{ selectedRenter.renterPreviousAddress || ('common.na' | t:'N/A') }}</span></div>
        <div class="details-item details-item-full">
          <span class="label">{{ 'renter.username' | t:'Username' }}</span>
          <div class="details-value-actions">
            <span class="value username-value">{{ isRenterUsernameVisible ? renterUsernameValue() : maskedRenterUsername() }}</span>
            <div class="details-inline-actions">
              <button
                type="button"
                class="details-mini-btn"
                (click)="toggleRenterUsernameVisibility()"
                [disabled]="renterUsernameValue() === 'N/A'"
              >
                {{ isRenterUsernameVisible ? ('common.hide' | t:'Hide') : ('common.show' | t:'Show') }}
              </button>
              <button
                type="button"
                class="details-mini-btn details-copy-btn"
                (click)="copyRenterUsername()"
                [disabled]="renterUsernameValue() === 'N/A'"
              >
                {{ renterUsernameCopied ? ('common.copied' | t:'Copied') : ('common.copy' | t:'Copy') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeRenterInfoModal()">{{ 'common.close' | t:'Close' }}</button>
      </div>
    </div>
  </div>

  <app-add-edit-renter
    *ngIf="isEditOpen && selectedRenter"
    [mode]="'edit'"
    [initialRenter]="selectedRenter"
    (close)="closeEditModal()"
    (save)="onEditSave($event)"
    (editDocuments)="openEditDocumentsModal()"
  ></app-add-edit-renter>

  <div class="modal-overlay" *ngIf="isUploadModalOpen" (click)="skipUploadModal()">
    <div class="details-modal upload-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="skipUploadModal()">&times;</button>
      <h3>{{ uploadMode === 'edit' ? ('renter.uploadModalEditTitle' | t:'Edit Renter Image') : ('renter.uploadModalCreateTitle' | t:'Upload Renter Image') }}</h3>
      <p class="upload-hint">{{ 'renter.uploadHint' | t:'Optional: You can skip this step and upload later.' }}</p>
      <p class="upload-hint subtle">{{ 'common.allowed' | t:'Allowed' }}: {{ renterAllowedExtensionsText }}</p>

      <div class="upload-existing" *ngIf="uploadExistingAttachments.length > 0">
        <div class="upload-count">{{ 'renter.existingFile' | t:'Existing file' }}</div>
        <div class="upload-files">
          <div class="upload-file" *ngFor="let file of uploadExistingAttachments; let i = index">
            <button
              type="button"
              class="existing-file-link"
              (click)="openAttachmentPreview(file)"
            >
              {{ file.attachmentFileName || ('Document #' + file.id) }}
            </button>
            <button type="button" class="remove-file" (click)="removeExistingAttachment(i)">{{ 'common.remove' | t:'Remove' }}</button>
          </div>
        </div>
      </div>

      <label class="upload-picker">
        <input
          type="file"
          accept=".jpg,.jpeg,.png"
          (change)="onUploadFilesSelected($event)"
        />
        <span>{{ 'renter.selectFile' | t:'Select File' }}</span>
      </label>

      <div class="upload-selected" *ngIf="uploadFiles.length > 0; else noUploadFile">
        <div class="upload-count">{{ uploadFiles.length }} {{ uploadFiles.length === 1 ? ('renter.fileSelectedSingular' | t:'file selected') : ('renter.fileSelectedPlural' | t:'files selected') }}</div>
        <div class="upload-files">
          <div class="upload-file" *ngFor="let file of uploadFiles; let i = index">
            <div class="upload-file-meta">
              <span class="name">{{ file.name }}</span>
              <span class="upload-file-size">{{ formatFileSize(file.size) }}</span>
            </div>
            <button type="button" class="remove-file" (click)="removeUploadFile(i)">{{ 'common.remove' | t:'Remove' }}</button>
          </div>
        </div>
      </div>
      <ng-template #noUploadFile>
        <div class="upload-empty">{{ 'renter.noFileSelected' | t:'No file selected.' }}</div>
      </ng-template>

      <div class="message error" *ngIf="uploadError">{{ uploadError }}</div>
      <div class="details-actions upload-actions">
        <button type="button" class="SecondaryBTN" (click)="skipUploadModal()">{{ 'common.skip' | t:'Skip' }}</button>
        <button type="button" class="PositiveBTN" (click)="uploadRenterImage()" [disabled]="isUploadingAttachment">
          {{ isUploadingAttachment ? ('common.saving' | t:'Saving...') : (uploadMode === 'edit' ? ('renter.saveImage' | t:'Save Image') : ('common.uploadingAction' | t:'Upload')) }}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay crop-overlay" *ngIf="isCropModalOpen" (click)="closeCropModal()">
    <div class="details-modal crop-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeCropModal()">&times;</button>
      <h3>{{ 'renter.cropModalTitle' | t:'Crop Renter Image' }}</h3>
      <p class="upload-hint">{{ 'renter.cropModalHint' | t:'Drag the image and adjust zoom to fit the profile area. The cropped image will be compressed before upload.' }}</p>
      <div class="crop-source-meta" *ngIf="cropSourceFile">
        <span class="crop-source-name">{{ cropSourceFile.name }}</span>
        <span class="crop-source-size">{{ formatFileSize(cropSourceFile.size) }}</span>
      </div>

      <div class="cropper-shell">
        <div
          #cropViewport
          class="cropper-viewport"
          [class.is-dragging]="isCropDragging"
          (pointerdown)="startCropDrag($event)"
          (pointermove)="onCropDrag($event)"
          (pointerup)="endCropDrag($event)"
          (pointercancel)="endCropDrag($event)"
          (wheel)="onCropWheel($event)"
        >
          <img
            *ngIf="cropSourceUrl"
            class="cropper-image"
            [src]="cropSourceUrl"
            [alt]="cropSourceName || 'Selected renter image'"
            [style.width.px]="cropImageNaturalWidth || null"
            [style.height.px]="cropImageNaturalHeight || null"
            [style.transform]="cropImageTransform()"
            draggable="false"
            (load)="onCropImageLoad($event)"
          />
          <div class="cropper-mask"></div>
        </div>
      </div>

      <div class="crop-controls">
        <label class="crop-zoom-control">
          <span>{{ 'common.zoom' | t:'Zoom' }}</span>
          <input type="range" min="1" max="4" step="0.05" [value]="cropZoom" (input)="onCropZoomChange($event)" />
        </label>
        <button type="button" class="details-mini-btn" (click)="resetCropTransform()">{{ 'common.reset' | t:'Reset' }}</button>
      </div>

      <p class="crop-note">{{ 'renter.cropOutputHint' | t:'The cropped image will be saved as JPG to reduce upload size.' }}</p>
      <div class="message error" *ngIf="cropError">{{ cropError }}</div>
      <div class="details-actions upload-actions">
        <button type="button" class="SecondaryBTN" (click)="closeCropModal()">{{ 'common.cancel' | t:'Cancel' }}</button>
        <button type="button" class="PositiveBTN" (click)="applyCropSelection()" [disabled]="isApplyingCrop">
          {{ isApplyingCrop ? ('common.saving' | t:'Saving...') : ('renter.useCroppedImage' | t:'Use Cropped Image') }}
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay preview-overlay" *ngIf="isImagePreviewOpen" (click)="closeImagePreview()">
    <div class="details-modal image-preview-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeImagePreview()">&times;</button>
      <button class="preview-download-btn" type="button" (click)="downloadPreviewImage()">{{ 'common.download' | t:'Download' }}</button>
      <h3>{{ imagePreviewName || ('common.preview' | t:'Preview') }}</h3>
      <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl" [alt]="imagePreviewName || 'Attachment preview'" class="preview-image" />
    </div>
  </div>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteRenter"
    [title]="'renter.deleteTitle' | t:'Delete Renter'"
    [message]="'renter.deleteMessage' | t:'Delete this renter?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteRenter()"
  ></app-confirm-action-modal>

  <app-confirm-action-modal
    [visible]="!!pendingRestoreRenter"
    [title]="'Restore Renter'"
    [message]="'Do you want to restore this renter?'"
    [confirmLabel]="'Restore'"
    [isLoading]="isRestoring"
    (cancel)="closeRestoreModal()"
    (confirm)="confirmRestoreRenter()"
  ></app-confirm-action-modal>

  <app-confirm-action-modal
    [visible]="pendingDeleteOnlyUpload"
    [title]="'action.delete' | t:'Delete'"
    [message]="'renter.deleteExistingImageConfirm' | t:'Do you want to delete this existing server image without uploading a new one?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [danger]="true"
    (cancel)="closeDeleteOnlyUploadModal()"
    (confirm)="confirmDeleteOnlyUpload()"
  ></app-confirm-action-modal>
</div>
